import { render, staticRenderFns } from "./HeaderSorting.vue?vue&type=template&id=ebae1370&scoped=true&"
import script from "./HeaderSorting.vue?vue&type=script&lang=ts&"
export * from "./HeaderSorting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebae1370",
  null
  
)

export default component.exports